import React from 'react'
import Products from '../components/Products'
import CategoryListing from './CategoryListing'
import { Route, Routes } from 'react-router-dom'

const AppRoutes = () => {
  return (
    <div style={{"backgroundColor": "#eceff1"}}>
      <div id="productCategory" className='container py-5'>
        <div className="text-center mb-5">
          <h1 className="text-primary fw-bold display-4 mb-3">Our Products</h1>
          <div className="border-bottom fw-bold border-primary mx-auto" style={{ width: '100%' }}></div>
        </div>
        <Routes>
          <Route path='/' element={<CategoryListing />} />
          <Route path="/products/:category" element={<Products/>} />
        </Routes>
      </div>
    </div>
  )
}

export default AppRoutes